import type {DateTimeString, TodoPriority, UserList, UserRef} from "@t/util/CommonTypes.ts";
import {isOfType, SrcType, WithType} from "@t/meta/SourceType.ts";
import {Event} from "@t/event/Event.ts";
import {Contact} from "@t/contact/Contact.ts";


export interface Task extends WithType {
	_type: 1;

	id: number;
	entered?: DateTimeString;
	enteredBy?: UserRef;
	modified?: DateTimeString;
	modifiedBy?: UserRef;
	deadline?: DateTimeString;
	owners?: UserList;
	responsibles?: UserList;
	mentions?: UserList;
	
	private: boolean;
	subject: string;
	description?: string;
	priority?: TodoPriority;
	ringBefore?: number;
	notification?: number;
	completed: boolean;
	notifyFlag?: number;
	agendaCategory?: string;
	symbol?: string;
	collectingFeedback?: boolean;
	
	customer?: number;
	branch?: number;
	person?: number;
	customerFileAs?: string;
	opportunity?: number;
	opportunityName?: string;
	busCase?: number;
	busCaseName?: string;
	problem?: number;
	problemFileAs?: string;
	campaign?: number;
	campaignSymbol?: string;
	project?: number;
	projectName?: string;
	sequence?: number;
	categories: string[];

	demandingnessStr?: string;
	demandingness?: number;
	qualityEvaluation?: number;
	percentCompleted?: number;

	suspended?: DateTimeString;
	strategicPriority?: number;
	workStart?: DateTimeString;
	workEnd?: DateTimeString;
	
	delegateTime?: DateTimeString;
	completeTime?: DateTimeString;
	acceptTime?: DateTimeString;

	/**
	 * This can contain a list (tree) of subtasks.
	 * If the property is missing, it means that subtasks weren't loaded yet.
	 * null or empty array means that the task isn't a project (has no subtasks).
	 */
	subtasks?: ProjectNode[];
}

export type ProjectNode = Task | Contact | Event;

export function isTask(obj: any): obj is Task {
	return isOfType(obj, SrcType.TASK);
}

export function hasLoadedSubtasks(task: Task): boolean {
	return task.subtasks !== undefined;
}
